'use client'

export { AuthBlockClient as AuthBlock } from './Component.client'
